import * as actionTypes from "../../../actions/fulfillment/types";

const INITIAL_STATE = {
  fetching: false,
  data: null,
  error: null,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case actionTypes.FULFILLMENT_PRODUCT_ACTIVITY_HISTORY_REQUESTED:
      return { ...state, fetching: true };
    case actionTypes.FULFILLMENT_PRODUCT_ACTIVITY_HISTORY_RECEIVED:
      return { ...state, fetching: false, data: action.data, error: null };
    case actionTypes.FULFILLMENT_PRODUCT_ACTIVITY_HISTORY_ERRORED:
      return { ...state, fetching: false, data: null, error: action.error };
    default:
      return state;
  }
}
